import React from 'react';

function Heading5({ size, ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...otherProps}
    >
      <path d="M 3 6, v 12" />
      <path d="M 3.5 12, h 8" />
      <path d="M 12 6, v 12" />
      <path d="M 17 11, v 3" />
      <path d="M17.0052 17.3835C18.5 18.5 20.5004 17.5 20.5007 16C20.501 14.4999 19.5 13.5 17.0013 14" />
      <path d="M 17 11, h 3" />
    </svg>
  );
}

export default Heading5;
